export const CIRCLE = 'M 0 10 A 10 10 0 1 1 0 -10 A 10 10 0 1 1 0 10 Z';

export const SQUARE = 'M -12 -12 L -12 12 L 12 12 L 12 -12 Z';

export const ARROW_HEAD = `M 11.2471 16.1721
  L 0 9.9211
  L 0 9.9211
  L -11.2472 16.1721
  C -11.7299 16.4404 -12.3388 16.2666 -12.6071 15.7838
  C -12.7501 15.5265 -12.7724 15.2191 -12.6681 14.9438
  L -0.9352 -16.0312
  C -0.7396 -16.5477 -0.1623 -16.8077 0.3542 -16.6121
  C 0.6221 -16.5106 0.8336 -16.2991 0.9351 -16.0312
  L 12.6681 14.9438
  C 12.8637 15.4603 12.6036 16.0376 12.0871 16.2332
  C 11.8118 16.3375 11.5045 16.3151 11.2471 16.1721
  Z`;

export const MAP_MARKER = `M 0.001 -19.968
  q 2.906 0 4.945 2.039
  t 2.039 4.945
  q 0 1.453 -0.727 3.328
  t -1.758 3.516
  t -2.039 3.07
  t -1.711 2.273
  l -0.75 0.797
  q -0.281 -0.328 -0.75 -0.867
  t -1.688 -2.156
  t -2.133 -3.141
  t -1.664 -3.445
  t -0.75 -3.375
  q 0 -2.906 2.039 -4.945
  t 4.945 -2.039
  Z`;

export default {
  CIRCLE,
  SQUARE,
  ARROW_HEAD,
  MAP_MARKER
};
